import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, Table } from 'primeng';
import { IDispute } from '../../interfaces/dispute';
import { IDisputeFilter } from '../../interfaces/dispute-filter';
import { IPageResult } from '../../interfaces/page-result';
import { DisputeService } from '../../services';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'dispute-list',
  templateUrl: './dispute-list.component.html',
  styleUrls: ['./dispute-list.component.css'],
})
export class DisputeListComponent implements OnInit {
  public page: IPageResult<IDispute> = {
    items: [],
    total: 0,
  };

  public isLoaded: boolean = false;
  public filterVal: IDisputeFilter;
  public filter: Subject<IDisputeFilter>;
  public selectedDispute = null;
  statusDispute: any[];

  constructor(
    private disputeService: DisputeService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.initDefaultFilter();
    this.filter = new Subject<IDisputeFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);

    this.statusDispute = [
      { label: 'All Status', value: null },
      { label: 'Open', value: 'Open' },
      { label: 'Resolved', value: 'Resolved' },
    ];
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'JobNumber',
      sortOrder: 1,
      filters: {
        jobNumber: { matchMode: 'contains' },
        customerCompanyName: { matchMode: 'contains' },
        supplierCompanyName: { matchMode: 'contains' },
        status: { matchMode: 'contains' },
      },
    };
  }

  load(filter: IDisputeFilter) {
    this.disputeService.getPage(filter).then((result) => {
      console.log('disputes result');
      console.log(result);
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    // map grid lazy load event to filter
    this.filter.next(this.filterVal);
  }

  onDisputeDetails(item) {
    this.displayDisputeDetails(item.id);
  }

  displayDisputeDetails(id: number) {
    this.router.navigate([id], { relativeTo: this.route });
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  openDispute(disputeId) {
    this.router.navigate(['app/dispute/' + disputeId]);
  }
}
